import { render, staticRenderFns } from "./SkeletonContainer.vue?vue&type=template&id=72b67898&scoped=true&"
import script from "./SkeletonContainer.vue?vue&type=script&lang=js&"
export * from "./SkeletonContainer.vue?vue&type=script&lang=js&"
import style0 from "./SkeletonContainer.vue?vue&type=style&index=0&id=72b67898&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72b67898",
  null
  
)

export default component.exports